module.exports = "../fonts/vendor/primevue/resources/themes/lara-light-indigo/Inter-Medium.woff2?293fd13dbca5a3e450ef1ebfb232a299";